function handleVideoPlay() {
  const sectionsWithVideoAutoplay = document.querySelectorAll('[data-video-autoplay]');
  if (sectionsWithVideoAutoplay.length === 0) return;

  sectionsWithVideoAutoplay.forEach((section) => {
    const videos = section.querySelectorAll('video');
    if (videos.length === 0) return;
    if (videos.length === 1) {
      observVideo(videos[0]);
    } else {
      const matchesBreakpoint = (video) => (window.innerWidth >= 990 && video.classList.contains('video-desktop')) || (window.innerWidth < 990 && video.classList.contains('video-mobile'));
      videos.forEach((video) => {
        if (matchesBreakpoint(video)) {
          observVideo(video);
        }
      });
    }
  });
}

function observVideo(video) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      });
    },
    {
      threshold: 0.1,
    }
  );
  observer.observe(video);
}

function handleVideoStart() {
  const sectionsWithVideoDeafult = document.querySelectorAll('[data-video-default]');
  if (sectionsWithVideoDeafult.length === 0) return;
  sectionsWithVideoDeafult.forEach((section) => {
    const videos = section.querySelectorAll('video');
    if (videos.length === 0) return;
    const playButton = section.querySelector('[data-play-video]');
    playButton.addEventListener('click', () => {
      if (videos.length === 1) {
        videos[0].play();
        playButton.style.display = 'none';
      } else {
        const matchesBreakpoint = (video) => (window.innerWidth >= 990 && video.classList.contains('video-desktop')) || (window.innerWidth < 990 && video.classList.contains('video-mobile'));
        videos.forEach((video) => {
          if (matchesBreakpoint(video)) {
            video.play();
            playButton.style.display = 'none';
          }
        });
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  handleVideoPlay();
  handleVideoStart();
});
